var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.039,
    height: 17.036,
    viewBox: "0 0 17.039 17.036",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.063 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18727.982-7800.857l14.914,14.915",
    transform: "translate(18727.982 7800.857)",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18713.068-7800.857l-14.914,14.915",
    transform: "translate(18727.982 7800.857)",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuIcon);
export default __webpack_public_path__ + "static/media/close_menu_icon.d5331badd6d869f12a5f24cdc3774eb2.svg";
export { ForwardRef as ReactComponent };